import PairingPlugin from './pairing/PluginSetup';
import LocationHoursPlugin from './locationHours/PluginSetup';
import SalesFlowPlugin from './salesFlow/PluginSetup';
import SaleVehicleLinkPlugin from './saleVehicleLink/PluginSetup';
import PositionPlugin from './position/PluginSetup';
import FindKeyPlugin from './findKey/PluginSetup';
import KeysUpsellPlugin from './keysUpsell/PluginSetup';
export default {
  install(molten) {
    PairingPlugin.install(molten);
    LocationHoursPlugin.install(molten);
    SalesFlowPlugin.install(molten);
    SaleVehicleLinkPlugin.install(molten);
    PositionPlugin.install(molten);
    FindKeyPlugin.install(molten);
    KeysUpsellPlugin.install(molten);
  }
};